/**
 * Skip Link Component (P2-1-4)
 *
 * キーボードユーザーがメインコンテンツに直接移動できるようにする
 * アクセシビリティ機能。通常は非表示で、Tab キーでフォーカスすると表示される。
 *
 * WCAG 2.1 AA - 2.4.1 Bypass Blocks
 */

import { forwardRef } from "react";
import { cn } from "@/lib/utils";

interface SkipLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children?: React.ReactNode;
}

const SkipLink = forwardRef<HTMLAnchorElement, SkipLinkProps>(
  ({ className, children = "メインコンテンツへスキップ", ...props }, ref) => {
    return (
      <a
        ref={ref}
        className={cn(
          // 通常は画面外に配置
          "sr-only",
          // フォーカス時に表示
          "focus:not-sr-only focus:absolute focus:z-50",
          "focus:top-4 focus:left-4",
          "focus:px-4 focus:py-2",
          "focus:bg-background focus:text-foreground",
          "focus:border focus:border-primary focus:rounded-md",
          "focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary",
          className
        )}
        {...props}
      >
        {children}
      </a>
    );
  }
);

SkipLink.displayName = "SkipLink";

export { SkipLink };
